import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const Relatorios = () => {
  return (
    <div>
      <h1>Relatorios</h1>
    </div>
  );
};

export default Relatorios;


// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Card } from "primereact/card";
// import { Dropdown } from "primereact/dropdown";
// import { Button } from "primereact/button";
// import { Calendar } from "primereact/calendar";
// import { TabView, TabPanel } from "primereact/tabview";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { Tag } from "primereact/tag";
// import { ProgressSpinner } from "primereact/progressspinner";
// import { Toast } from "primereact/toast";
// import { useAuth } from "../../../AuthContext";
// import {
//   FaFileAlt,
//   FaChartBar,
//   FaUserTie,
//   FaCalendarAlt,
//   FaVoteYea,
//   FaFilePdf,
//   FaFileExcel,
//   FaPrint,
//   FaUsers,
// } from "react-icons/fa";
// import * as XLSX from "xlsx";

// const API_BASE_URL = "https://sapl.cantarellisolucoes.com.br/wp-json/custom/v1";

// const Relatorios = () => {
//   const { user } = useAuth();
//   const toast = useRef(null);

//   // Estados
//   const [loading, setLoading] = useState(false);
//   const [legislaturas, setLegislaturas] = useState([]);
//   const [legislaturaSelecionada, setLegislaturaSelecionada] = useState(null);
//   const [parlamentares, setParlamentares] = useState([]);
//   const [tiposMateria, setTiposMateria] = useState([]);
//   const [statusMateria, setStatusMateria] = useState([]);
//   const [sessoes, setSessoes] = useState([]);

//   // Filtros
//   const [dataInicio, setDataInicio] = useState(null);
//   const [dataFim, setDataFim] = useState(null);
//   const [parlamentarSelecionado, setParlamentarSelecionado] = useState(null);
//   const [tipoSelecionado, setTipoSelecionado] = useState(null);
//   const [statusSelecionado, setStatusSelecionado] = useState(null);

//   // Dados dos relatórios
//   const [relatorioMaterias, setRelatorioMaterias] = useState([]);
//   const [relatorioPresenca, setRelatorioPresenca] = useState([]);
//   const [relatorioVotacoes, setRelatorioVotacoes] = useState([]);
//   const [relatorioProdutividade, setRelatorioProdutividade] = useState([]);

//   // Função genérica para requisições
//   const apiRequest = async (endpoint, options = {}) => {
//     const url = `${API_BASE_URL}${endpoint}`;
//     const response = await fetch(url, {
//       ...options,
//       headers: {
//         Authorization: `Bearer ${user?.token}`,
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         ...options.headers,
//       },
//       credentials: "include",
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       throw { status: response.status, data };
//     }

//     return data;
//   };

//   // Carregar dados iniciais
//   const carregarDados = useCallback(async () => {
//     try {
//       const [legislaturasRes, parlamentaresRes, tiposRes, statusRes, sessoesRes] = await Promise.all([
//         apiRequest("/legislaturas"),
//         apiRequest("/parlamentares?ativo=true"),
//         apiRequest("/tipos-materia"),
//         apiRequest("/status-materia"),
//         apiRequest("/sessoes"),
//       ]);

//       setLegislaturas(legislaturasRes.data || []);
//       setParlamentares(parlamentaresRes.data || []);
//       setTiposMateria(tiposRes.data || []);
//       setStatusMateria(statusRes.data || []);
//       setSessoes(sessoesRes.data || []);

//       const atual = legislaturasRes.data?.find((l) => l.ativa === 1);
//       if (atual) setLegislaturaSelecionada(atual);
//     } catch (error) {
//       console.error("Erro ao carregar dados:", error);
//     }
//   }, [user?.token]);

//   useEffect(() => {
//     if (user?.token) {
//       carregarDados();
//     }
//   }, [user?.token, carregarDados]);

//   // Gerar relatório de matérias
//   const gerarRelatorioMaterias = async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (legislaturaSelecionada?.id) params.append("legislatura_id", legislaturaSelecionada.id);
//       if (tipoSelecionado) params.append("tipo", tipoSelecionado);
//       if (statusSelecionado) params.append("status", statusSelecionado);
//       if (dataInicio) params.append("data_inicio", dataInicio.toISOString().split("T")[0]);
//       if (dataFim) params.append("data_fim", dataFim.toISOString().split("T")[0]);

//       const response = await apiRequest(`/materias?${params.toString()}`);
//       setRelatorioMaterias(response.data || []);
      
//       toast.current?.show({
//         severity: "success",
//         summary: "Relatório gerado",
//         detail: `${response.data?.length || 0} matérias encontradas`,
//         life: 3000,
//       });
//     } catch (error) {
//       console.error("Erro ao gerar relatório:", error);
//       toast.current?.show({
//         severity: "error",
//         summary: "Erro",
//         detail: "Falha ao gerar relatório",
//         life: 5000,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Gerar relatório de produtividade por parlamentar
//   const gerarRelatorioProdutividade = async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (legislaturaSelecionada?.id) params.append("legislatura_id", legislaturaSelecionada.id);
//       if (dataInicio) params.append("data_inicio", dataInicio.toISOString().split("T")[0]);
//       if (dataFim) params.append("data_fim", dataFim.toISOString().split("T")[0]);

//       const response = await apiRequest(`/materias?${params.toString()}`);
//       const materias = response.data || [];
      
//       // Agrupar por autor
//       const produtividade = {};
//       materias.forEach(materia => {
//         const autorId = materia.autor_id;
//         const autorNome = materia.autor_nome || "Não informado";
//         if (!produtividade[autorId]) {
//           produtividade[autorId] = {
//             autor_id: autorId,
//             autor_nome: autorNome,
//             partido: materia.autor_partido,
//             total: 0,
//             aprovadas: 0,
//             rejeitadas: 0,
//             em_tramitacao: 0,
//           };
//         }
//         produtividade[autorId].total++;
//         if (materia.status === "aprovada") produtividade[autorId].aprovadas++;
//         else if (materia.status === "rejeitada") produtividade[autorId].rejeitadas++;
//         else if (materia.status === "em_tramitacao") produtividade[autorId].em_tramitacao++;
//       });
      
//       setRelatorioProdutividade(Object.values(produtividade));
      
//       toast.current?.show({
//         severity: "success",
//         summary: "Relatório gerado",
//         detail: `${Object.values(produtividade).length} parlamentares com matérias`,
//         life: 3000,
//       });
//     } catch (error) {
//       console.error("Erro ao gerar relatório:", error);
//       toast.current?.show({
//         severity: "error",
//         summary: "Erro",
//         detail: "Falha ao gerar relatório",
//         life: 5000,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Exportar para Excel
//   const exportToExcel = (data, filename) => {
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Relatório");
//     XLSX.writeFile(wb, `${filename}.xlsx`);
//     toast.current?.show({
//       severity: "success",
//       summary: "Exportado",
//       detail: "Arquivo Excel gerado com sucesso",
//       life: 3000,
//     });
//   };

//   // Templates da tabela de matérias
//   const statusMateriaBody = (rowData) => {
//     const status = statusMateria.find(s => s.valor === rowData.status);
//     return <Tag value={status?.label || rowData.status} severity={status?.severity || "secondary"} />;
//   };

//   const tipoMateriaBody = (rowData) => {
//     const tipo = tiposMateria.find(t => t.valor === rowData.tipo);
//     return <Tag value={tipo?.label || rowData.tipo} severity="info" />;
//   };

//   // Templates da tabela de produtividade
//   const produtividadeBody = (rowData) => (
//     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//       <div style={{
//         width: "32px",
//         height: "32px",
//         borderRadius: "50%",
//         backgroundColor: "#f3f4f6",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         color: "#3b82f6",
//       }}>
//         <FaUserTie size={14} />
//       </div>
//       <div>
//         <div style={{ fontWeight: "500" }}>{rowData.autor_nome}</div>
//         <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>{rowData.partido || "Sem partido"}</div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="dashboard-container">
//       <Toast ref={toast} />

//       <div className="dashboard-header">
//         <h1>Relatórios</h1>
//         <p>Análise e exportação de dados do sistema legislativo</p>
//       </div>

//       <div className="page-content">
//         {/* Filtros Globais */}
//         <Card style={{ padding: "0", marginBottom: "10px" }}>
//           <div style={{ padding: "0 10px" }}>
//             <h2 style={{ margin: 0, color: "#374151" }}>Filtros Gerais</h2>
//           </div>
//           <div style={{ padding: "0 10px" }}>
//             <div className="grid p-fluid">
//               <div className="col-12 md:col-4">
//                 <label className="font-semibold mb-1">Legislatura</label>
//                 <Dropdown
//                   value={legislaturaSelecionada}
//                   options={legislaturas}
//                   onChange={(e) => setLegislaturaSelecionada(e.value)}
//                   optionLabel="descricao"
//                   placeholder="Selecione a legislatura"
//                   showClear
//                 />
//               </div>
//               <div className="col-12 md:col-4">
//                 <label className="font-semibold mb-1">Data Início</label>
//                 <Calendar
//                   value={dataInicio}
//                   onChange={(e) => setDataInicio(e.value)}
//                   dateFormat="dd/mm/yy"
//                   placeholder="dd/mm/aaaa"
//                   showIcon
//                 />
//               </div>
//               <div className="col-12 md:col-4">
//                 <label className="font-semibold mb-1">Data Fim</label>
//                 <Calendar
//                   value={dataFim}
//                   onChange={(e) => setDataFim(e.value)}
//                   dateFormat="dd/mm/yy"
//                   placeholder="dd/mm/aaaa"
//                   showIcon
//                 />
//               </div>
//             </div>
//           </div>
//         </Card>

//         {/* Abas de Relatórios */}
//         <TabView className="tabview-colada">
//           <TabPanel header="Matérias Legislativas" headerClassName="tab-header-colada">
//             <div style={{ backgroundColor: "#fafafa", border: "1px solid #e8e8e8", borderTop: "none", padding: "15px", borderRadius: "0 0 12px 12px" }}>
//               <div className="grid p-fluid" style={{ marginBottom: "15px" }}>
//                 <div className="col-12 md:col-5">
//                   <label className="font-semibold mb-1">Tipo de Matéria</label>
//                   <Dropdown
//                     value={tipoSelecionado}
//                     options={tiposMateria}
//                     onChange={(e) => setTipoSelecionado(e.value)}
//                     optionLabel="label"
//                     placeholder="Todos"
//                     showClear
//                   />
//                 </div>
//                 <div className="col-12 md:col-5">
//                   <label className="font-semibold mb-1">Status</label>
//                   <Dropdown
//                     value={statusSelecionado}
//                     options={statusMateria}
//                     onChange={(e) => setStatusSelecionado(e.value)}
//                     optionLabel="label"
//                     placeholder="Todos"
//                     showClear
//                   />
//                 </div>
//                 <div className="col-12 md:col-2" style={{ display: "flex", alignItems: "flex-end", gap: "8px" }}>
//                   <Button label="Gerar" icon="pi pi-chart-bar" severity="primary" onClick={gerarRelatorioMaterias} loading={loading} />
//                   <Button label="Excel" icon="pi pi-file-excel" severity="success" onClick={() => exportToExcel(relatorioMaterias, "relatorio_materias")} disabled={relatorioMaterias.length === 0} outlined />
//                 </div>
//               </div>

//               {loading ? (
//                 <div className="loading-container"><ProgressSpinner /></div>
//               ) : (
//                 <DataTable value={relatorioMaterias} paginator rows={10} showGridlines stripedRows emptyMessage="Nenhuma matéria encontrada">
//                   <Column field="tipo" header="Tipo" body={tipoMateriaBody} style={{ width: "140px" }} />
//                   <Column header="Nº/Ano" body={(rowData) => `${rowData.numero}/${rowData.ano}`} style={{ width: "100px" }} />
//                   <Column field="ementa" header="Ementa" style={{ minWidth: "300px" }} />
//                   <Column field="autor_nome" header="Autor" style={{ width: "180px" }} />
//                   <Column field="status" header="Status" body={statusMateriaBody} style={{ width: "120px" }} />
//                   <Column field="data_apresentacao" header="Data" body={(rowData) => new Date(rowData.data_apresentacao).toLocaleDateString("pt-BR")} style={{ width: "100px" }} />
//                 </DataTable>
//               )}
//             </div>
//           </TabPanel>

//           <TabPanel header="Produtividade Parlamentar" headerClassName="tab-header-colada">
//             <div style={{ backgroundColor: "#fafafa", border: "1px solid #e8e8e8", borderTop: "none", padding: "15px", borderRadius: "0 0 12px 12px" }}>
//               <div style={{ marginBottom: "15px" }}>
//                 <Button label="Gerar Relatório" icon="pi pi-chart-bar" severity="primary" onClick={gerarRelatorioProdutividade} loading={loading} />
//                 <Button label="Exportar Excel" icon="pi pi-file-excel" severity="success" onClick={() => exportToExcel(relatorioProdutividade, "relatorio_produtividade")} disabled={relatorioProdutividade.length === 0} outlined style={{ marginLeft: "8px" }} />
//               </div>

//               {loading ? (
//                 <div className="loading-container"><ProgressSpinner /></div>
//               ) : (
//                 <DataTable value={relatorioProdutividade} paginator rows={10} showGridlines stripedRows emptyMessage="Nenhum dado encontrado">
//                   <Column header="Parlamentar" body={produtividadeBody} style={{ width: "250px" }} />
//                   <Column field="total" header="Total" sortable style={{ width: "100px" }} />
//                   <Column field="aprovadas" header="Aprovadas" sortable style={{ width: "100px" }} />
//                   <Column field="rejeitadas" header="Rejeitadas" sortable style={{ width: "100px" }} />
//                   <Column field="em_tramitacao" header="Em Tramitação" sortable style={{ width: "120px" }} />
//                   <Column header="Aproveitamento" body={(rowData) => `${rowData.total ? Math.round((rowData.aprovadas / rowData.total) * 100) : 0}%`} sortable style={{ width: "120px" }} />
//                 </DataTable>
//               )}
//             </div>
//           </TabPanel>

//           <TabPanel header="Resumo Geral" headerClassName="tab-header-colada">
//             <div style={{ backgroundColor: "#fafafa", border: "1px solid #e8e8e8", borderTop: "none", padding: "15px", borderRadius: "0 0 12px 12px" }}>
//               <div className="grid">
//                 <div className="col-12 md:col-4">
//                   <Card style={{ textAlign: "center", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white" }}>
//                     <FaFileAlt size={32} />
//                     <h2 style={{ margin: "10px 0", color: "white" }}>{relatorioMaterias.length}</h2>
//                     <p>Matérias Cadastradas</p>
//                   </Card>
//                 </div>
//                 <div className="col-12 md:col-4">
//                   <Card style={{ textAlign: "center", background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", color: "white" }}>
//                     <FaUsers size={32} />
//                     <h2 style={{ margin: "10px 0", color: "white" }}>{parlamentares.length}</h2>
//                     <p>Parlamentares Ativos</p>
//                   </Card>
//                 </div>
//                 <div className="col-12 md:col-4">
//                   <Card style={{ textAlign: "center", background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)", color: "white" }}>
//                     <FaVoteYea size={32} />
//                     <h2 style={{ margin: "10px 0", color: "white" }}>{sessoes.filter(s => s.status === "encerrada").length}</h2>
//                     <p>Sessões Realizadas</p>
//                   </Card>
//                 </div>
//               </div>
//             </div>
//           </TabPanel>
//         </TabView>
//       </div>
//     </div>
//   );
// };

// export default Relatorios;